export const FETCH_ICD10 = '@icd/FETCH_ICD10';
export const FETCH_ICD10_SUCCESS = '@icd/FETCH_ICD10_SUCCESS';
export const FETCH_ICD10_FAIL = '@icd/FETCH_ICD10_FAIL';